module.exports = __webpack_public_path__ + "static/img/case10.5325db5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ServiceCase/case10.png
// module id = HZpf
// module chunks = 1